import { lazy } from 'react';
import { SUPPORT_PERMISSIONS } from './constants';

const TicketListPage = lazy(() => import('./pages/TicketListPage'));
const TicketDetailPage = lazy(() => import('./pages/TicketDetailPage'));
const FaqPage = lazy(() => import('./pages/FaqPage'));
const VideosPage = lazy(() => import('./pages/VideosPage'));

export const supportRoutes = [
  {
    path: '/support/tickets',
    element: TicketListPage,
    permission: SUPPORT_PERMISSIONS.WRITE,
    nav: { labelKey: 'nav.support', icon: 'CustomerServiceOutlined', group: 'operations' },
  },
  { path: '/support/tickets/:id', element: TicketDetailPage, permission: SUPPORT_PERMISSIONS.WRITE, nav: null },
  {
    path: '/support/faq',
    element: FaqPage,
    permission: SUPPORT_PERMISSIONS.WRITE,
    nav: { labelKey: 'nav.faq', icon: 'QuestionCircleOutlined', group: 'operations' },
  },
  {
    path: '/support/videos',
    element: VideosPage,
    permission: SUPPORT_PERMISSIONS.WRITE,
    nav: { labelKey: 'nav.helpVideos', icon: 'PlayCircleOutlined', group: 'operations' },
  },
];
